var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.showFirst
    ? _c(
        "cargo-ag-grid",
        _vm._g(
          _vm._b(
            {
              key: "1",
              ref: "grid",
              attrs: {
                "grid-options": _vm.gridOptions,
                "column-defs": _vm.finalColumnDefs,
                "config-module": _vm.configModule,
                "pre-column-state-callback": _vm.preColumnStateCallbackWrap,
                "custom-menu-items": _vm.customMenuItems,
                "row-data": _vm.rowData,
                "use-cache-init": _vm.useCacheInit,
                "show-menu-items": _vm.showMenuItems
              },
              on: {
                "update:useCacheInit": function($event) {
                  _vm.useCacheInit = $event
                },
                "update:use-cache-init": function($event) {
                  _vm.useCacheInit = $event
                },
                gridReady: _vm.onGridReady,
                columnRowGroupChanged: _vm.onColumnRowGroupChanged
              }
            },
            "cargo-ag-grid",
            _vm.$attrs,
            false
          ),
          _vm.$listeners
        )
      )
    : _c(
        "cargo-ag-grid",
        _vm._g(
          _vm._b(
            {
              key: "2",
              ref: "grid",
              attrs: {
                "grid-options": _vm.gridOptions,
                "column-defs": _vm.finalColumnDefs,
                "config-module": _vm.configModule,
                "pre-column-state-callback": _vm.preColumnStateCallbackWrap,
                "custom-menu-items": _vm.customMenuItems,
                "row-data": _vm.rowData,
                "use-cache-init": _vm.useCacheInit,
                "show-menu-items": _vm.showMenuItems
              },
              on: {
                "update:useCacheInit": function($event) {
                  _vm.useCacheInit = $event
                },
                "update:use-cache-init": function($event) {
                  _vm.useCacheInit = $event
                },
                gridReady: _vm.onGridReady,
                columnRowGroupChanged: _vm.onColumnRowGroupChanged
              }
            },
            "cargo-ag-grid",
            _vm.$attrs,
            false
          ),
          _vm.$listeners
        )
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }